import { render, staticRenderFns } from "./Invites.vue?vue&type=template&id=e644c940&scoped=true&"
import script from "./Invites.vue?vue&type=script&lang=js&"
export * from "./Invites.vue?vue&type=script&lang=js&"
import style0 from "./Invites.vue?vue&type=style&index=0&id=e644c940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e644c940",
  null
  
)

export default component.exports